<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <core-card [actions]="[]">
        <div class="card-title w-100">
          <div class="row mb-1">
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="searchDeal(); changeQueryParams()" />
            </div>
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select
                class="font-small-4 font-weight-normal"
                id="commercial_timeMaterial"
                bindLabel="complete_name"
                bindValue="complete_name"
                [multiple]="false"
                [searchable]="true"
                [closeOnSelect]="true"
                [clearable]="false"
                [openOnEnter]="false"
                [virtualScroll]="true"
                [(ngModel)]="filter_commercial"
                (ngModelChange)="searchDeal(); changeQueryParams()"
              >
                <ng-option [value]="''">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER_COMMERCIAL" | translate }}</span>
                </ng-option>
                <ng-option *ngFor="let commercial of commercial_list" [value]="commercial.complete_name">
                  <span class="font-small-4 font-weight-normal pr-2">{{ commercial.complete_name }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
              <ng-select [(ngModel)]="filter_typology" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchDeal(); changeQueryParams()">
                <ng-option [value]="''">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "TYPOLOGY" | translate }}</span>
                </ng-option>
                <ng-option [value]="'Time Material'">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "TIME_MATERIAL" | translate }}</span>
                </ng-option>
                <ng-option [value]="'Task'">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "TASK" | translate }}</span>
                </ng-option>
                <ng-option [value]="'Product'">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "PRODUCT" | translate }}</span>
                </ng-option>
              </ng-select>
            </div>
            <div class="col-xl-3 col-12">
              <ng-select [(ngModel)]="filter_customer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [clearable]="false" (ngModelChange)="searchDeal(); changeQueryParams()">
                <ng-option [value]="0">
                  <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}</span>
                </ng-option>
                <ng-option [value]="customer.id" *ngFor="let customer of customers_list">
                  <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
                </ng-option>
              </ng-select>
            </div>
          </div>
          <div class="row">
            <div class="col-12 text-right" [ngClass.sm]="'col-12 mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <div class="btn-group" *ngIf="_authenticationService.hasCapability('create_deal')">
                <div ngbDropdown>
                  <button ngbDropdownToggle class="btn btn-outline-primary" type="button" id="dropdownMenuButton2" rippleEffect> {{ "ADD" | translate }}</button>
                  <div ngbDropdownMenu aria-labelledby="dropdownMenuButton2">
                    <a ngbDropdownItem href="javascript:void(0)" routerLink="/dashboard/deals/create" [queryParams]="{ type: 'Task' }">{{ "TASK" | translate }}</a>
                    <a ngbDropdownItem href="javascript:void(0)" routerLink="/dashboard/deals/create" [queryParams]="{ type: 'Time Material' }">{{ "TIME_MATERIAL" | translate }}</a>
                    <a ngbDropdownItem href="javascript:void(0)" routerLink="/dashboard/deals/create-product-deal">{{ "PRODUCT" | translate }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pb-0">
          <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [scrollbarH]="true" [rowHeight]="_utilService.isDesktop ? 70 : 210" [limit]="tableLimit" [footerHeight]="50" [rows]="filterDeals" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }">
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="_utilService.isDesktop" width="330">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a *ngIf="row.deal_type === 'Task' || row.deal_type === 'Time Material'" class="text-break-line-2"
                   [ngbTooltip]="row.name" [routerLink]="_authenticationService.hasCapability('edit_deal') ? '/dashboard/deals/edit/' + row.id : null">{{ row.complete_name }}</a>
                <a *ngIf="row.deal_type === 'Product'" class="text-break-line-2" [ngbTooltip]="row.name"
                   [routerLink]="_authenticationService.hasCapability('edit_deal') ? '/dashboard/deals/edit-product-deal/' + row.id : null">{{ row.complete_name }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'CUSTOMER_COMMERCIAL' | translate" prop="commercial.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.commercial?.complete_name }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FROM' | translate" prop="start_date" *ngIf="_utilService.isDesktop" width="50">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.formatDate(row.from ? row.from : row.start_date) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TO' | translate" prop="end_date" *ngIf="_utilService.isDesktop" width="50">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ _utilService.formatDate(row.to ? row.to : row.end_date) }}</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TYPOLOGY' | translate" prop="deal_type" *ngIf="_utilService.isDesktop" width="100">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span class="ml-075" *ngIf="row.deal_type && row.deal_type === 'Time Material'" [ngbTooltip]="'TIME_MATERIAL' | translate"> <i [data-feather]="'clock'" size="19"></i></span>
                <span class="ml-075" *ngIf="row.deal_type && row.deal_type === 'Task'" [ngbTooltip]="'TASK' | translate"> <i [data-feather]="'calendar'" size="19"></i></span>
                <span class="ml-075" *ngIf="row.deal_type && row.deal_type === 'Product'" [ngbTooltip]="'PRODUCT' | translate"> <i [data-feather]="'package'" size="19"></i></span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'RESOURCES' | translate" *ngIf="_utilService.isDesktop" [sortable]="false" width="70">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span
                  [ngbTooltip]="descriptionTooltip(row.description)"
                  placement="top-left"
                  [ngStyle]="{ width: '150px' }"
                  *ngIf="!!row.description && row.description.length === 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')"
                >
                  <i [data-feather]="'user'" size="19"></i>
                </span>
                <span
                  [ngbTooltip]="descriptionTooltip(row.description)"
                  placement="top-left"
                  [ngStyle]="{ width: '150px' }"
                  *ngIf="!!row.description && row.description.length > 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')"
                >
                  <i [data-feather]="'users'" size="19"></i>
                </span>
                <span [ngbTooltip]="descriptionTooltip(row.description)" placement="top-left" [ngStyle]="{ width: '150px' }" *ngIf="!!row.description && row.description.length > 0 && row.deal_type === 'Product'">
                  <i [data-feather]="'package'" size="19"></i>
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'DEAL_ORDER' | translate" prop="commission.name" *ngIf="_utilService.isDesktop" width="90">
              <ng-template ngx-datatable-cell-template let-row="row">
                <!-- bottone commessa per task e time material -->
                <div *ngIf="(row.deal_type === 'Task' || row.deal_type === 'Time Material') && (!row.commission || (!row.commission.name && !row.commission.id))" ngbDropdown>
                  <button ngbDropdownToggle [ngbTooltip]="'CREATE_COMMISSION' | translate" placement="bottom-left" class="btn px-0 py-0 mt-075 font-weight-normal no-arrow" type="button" id="dropdown-{{ row.id }}" rippleEffect>
                    <span class="text-center text-success">
                      <i data-feather="plus" size="19"></i>
                    </span>
                  </button>
                  <div ngbDropdownMenu [style.margin-left.px]="-40" aria-labelledby="dropdown-{{ row.id }}">
                    <a ngbDropdownItem href="javascript:void(0)" [routerLink]="'/dashboard/commission/create'" [queryParams]="{ deal: row.id }" *ngIf="_authenticationService.hasCapability('create_commission')">
                      {{ "CREATE_COMMISSION" | translate }}
                    </a>
                    <a ngbDropdownItem *ngIf="_authenticationService.hasCapability('create_commission')" [routerLink]="'/dashboard/commission/create'" [queryParams]="{ deal: row.id, detachment: true }">{{
                        "CREATE_DETACHMENT" | translate
                      }}</a>
                    <a ngbDropdownItem (click)="modalOpen(chooseCommission, row)" *ngIf="_authenticationService.hasCapability('edit_commission')">
                      {{ "INSERT_TO_EXISTING_COMMISSION" | translate }}
                    </a>
                  </div>
                </div>
                <!-- bottone commessa per prodotti -->
                <div *ngIf="row.deal_type === 'Product' && (!row.commission || (!row.commission.name && !row.commission.id))" ngbDropdown>
                  <button ngbDropdownToggle [ngbTooltip]="'CREATE_COMMISSION' | translate" placement="left" class="btn px-0 py-0 mt-075 font-weight-normal" type="button" id="dropdown-{{ row.id }}" rippleEffect>
                    <span class="text-center text-success">
                      <i data-feather="plus" size="19"></i>
                    </span>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdown-{{ row.id }}">
                    <a
                      ngbDropdownItem
                      href="javascript:void(0)"
                      [routerLink]="'/dashboard/commissions/create-product-commission'"
                      [queryParams]="{ deal: row.id }"
                      *ngIf="_authenticationService.hasCapability('create_commission')"
                    >
                      {{ "CREATE_COMMISSION" | translate }}
                    </a>
                    <a ngbDropdownItem (click)="modalOpen(chooseCommission, row)" *ngIf="_authenticationService.hasCapability('edit_commission')">
                      {{ "INSERT_TO_EXISTING_COMMISSION" | translate }}
                    </a>
                  </div>
                </div>
                <a routerLink="/dashboard/commissions/edit-product-commission/{{ row.commission.id }}" *ngIf="!!row.commission && row.deal_type === 'Product'">{{ row.commission.name }}</a>
                <a routerLink="/dashboard/commission/edit/{{ row.commission.id }}" *ngIf="!!row.commission && row.deal_type !== 'Product'">{{ row.commission.name }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop" [width]="70">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex justify-content-start">
                  <a
                    class="text-success"
                    [ngbTooltip]="'VIEW_FILE_DOCUMENT' | translate"
                    (click)="_utilService.getFile(row.document_url)"
                    *ngIf="_authenticationService.hasCapability('manage_deal_document') && row.document_url"
                  >
                    <span [data-feather]="'file-text'" size="19"></span>
                  </a>
                  <a
                    class="text-warning"
                    [ngbTooltip]="'GENERATE_PDF_DOCUMENT' | translate"
                    (click)="generateDocument(row.id, !!row.document_url, row.deal_type)"
                    *ngIf="!row.document_url && _authenticationService.hasCapability('manage_deal_document')"
                  >
                    <span [data-feather]="'download'" size="19"></span>
                  </a>
                  <a
                    *ngIf="row.deal_type === 'Task' || row.deal_type === 'Time Material'"
                    class="text-secondary ml-1" has_capability="create_deal"
                    [ngbTooltip]="'DUPLICATE_OFFER' | translate"
                    [routerLink]="'/dashboard/deals/duplicate/' + row.id"
                  ><span [data-feather]="'copy'" size="19"></span
                  ></a>
                  <a
                    *ngIf="row.deal_type === 'Product'"
                    class="text-secondary ml-1" has_capability="create_deal"
                    [ngbTooltip]="'DUPLICATE_OFFER' | translate"
                    [routerLink]="'/dashboard/deals/duplicate-product-deal/' + row.id"
                  ><span [data-feather]="'copy'" size="19"></span
                  ></a>
                  <a (click)="delete(row)" class="text-danger remove-item ml-1" *ngIf="_authenticationService.hasCapability('delete_deal')" [ngbTooltip]="'DELETE' | translate">
                    <span [data-feather]="'trash-2'" size="19"></span>
                  </a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <a
                      *ngIf="row.deal_type === 'Task' || row.deal_type === 'Time Material'"
                      class="text-break-line-2"
                      [ngbTooltip]="row.name"
                      [routerLink]="_authenticationService.hasCapability('edit_deal') ? '/dashboard/deals/edit/' + row.id : null"
                    >{{ row.complete_name }}</a
                    >
                    <a
                      *ngIf="row.deal_type === 'Product'"
                      class="text-break-line-2"
                      [ngbTooltip]="row.name"
                      [routerLink]="_authenticationService.hasCapability('edit_deal') ? '/dashboard/deals/edit-product-deal/' + row.id : null"
                    >{{ row.complete_name }}</a
                    >
                  </div>
                  <div class="col-12">
                    <!--commerciale-->
                    <span class="font-weight-bold">{{ "CUSTOMER_COMMERCIAL" | translate }}: </span>
                    <span>{{ row.commercial?.complete_name }}</span>
                  </div>
                  <div class="col-12">
                    <!--tipologia-->
                    <span class="font-weight-bold">{{ "TYPOLOGY" | translate }}: </span>
                    <span
                      [ngbTooltip]="descriptionTooltip(row.description)"
                      placement="top-left"
                      [ngStyle]="{ width: '150px' }"
                      *ngIf="!!row.description && row.description.length === 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')"
                    >
                      <i [data-feather]="'user'" size="19"></i>
                    </span>
                    <span
                      [ngbTooltip]="descriptionTooltip(row.description)"
                      placement="top-left"
                      [ngStyle]="{ width: '150px' }"
                      *ngIf="!!row.description && row.description.length > 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')"
                    >
                      <i [data-feather]="'users'" size="19"></i>
                    </span>
                    <span [ngbTooltip]="descriptionTooltip(row.description)" placement="top-left" [ngStyle]="{ width: '150px' }" *ngIf="!!row.description && row.description.length > 0 && row.deal_type === 'Product'">
                      <i [data-feather]="'package'" size="19"></i>
                    </span>
                  </div>
                  <div class="col-12">
                    <!--descrizione/attività-->
                    <span *ngIf="!!row.description && row.description.length === 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')" ngbDropdown class="d-flex align-items-center w-100">
                      <i [data-feather]="'user'" size="19"></i>
                      <div class="w-100" id="dropdownMenuButton3" ngbDropdownToggle>
                        <span class="ml-1">{{ "EMPLOYEES_AND_PRODUCTS" | translate }}</span>
                      </div>
                      <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton3">
                        <button class="dropdown-item" *ngFor="let person of row.description">
                          {{ person }}
                        </button>
                      </div>
                    </span>
                    <span *ngIf="!!row.description && row.description.length > 1 && (row.deal_type === 'Task' || row.deal_type === 'Time Material')" ngbDropdown class="d-flex align-items-center w-100">
                      <i [data-feather]="'users'" size="19"></i>
                      <div class="w-100" id="dropdownMenuButton4" ngbDropdownToggle>
                        <span class="ml-1">{{ "EMPLOYEES_AND_PRODUCTS" | translate }}</span>
                      </div>
                      <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton4">
                        <button class="dropdown-item" *ngFor="let person of row.description">
                          {{ person }}
                        </button>
                      </div>
                    </span>
                    <span *ngIf="!!row.description && row.description.length > 0 && row.deal_type === 'Product'" ngbDropdown class="d-flex align-items-center w-100">
                      <i [data-feather]="'package'" size="19"></i>
                      <div class="w-100" id="dropdownMenuButton5" ngbDropdownToggle>
                        <span class="ml-1">{{ "EMPLOYEES_AND_PRODUCTS" | translate }}</span>
                      </div>
                      <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton5">
                        <button class="dropdown-item" *ngFor="let product of row.description">
                          {{ product }}
                        </button>
                      </div>
                    </span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "DEAL_ORDER" | translate }}: </span>
                    <!-- bottone commessa per task e time material -->
                    <span *ngIf="(row.deal_type === 'Task' || row.deal_type === 'Time Material') && (!row.commission || (!row.commission.name && !row.commission.id))" ngbDropdown>
                      <button ngbDropdownToggle [ngbTooltip]="'CREATE_COMMISSION' | translate" placement="left" class="btn px-0 py-0 font-weight-normal" type="button" id="dropdown-{{ row.id }}" rippleEffect>
                        <span class="text-center text-success">
                          <i data-feather="plus" size="19"></i>
                        </span>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdown-{{ row.id }}">
                        <a ngbDropdownItem href="javascript:void(0)" [routerLink]="'/dashboard/commission/create'" [queryParams]="{ deal: row.id }" *ngIf="_authenticationService.hasCapability('create_commission')">
                          {{ "CREATE_COMMISSION" | translate }}
                        </a>
                        <a ngbDropdownItem *ngIf="_authenticationService.hasCapability('create_commission')" [routerLink]="'/dashboard/commission/create'" [queryParams]="{ deal: row.id, detachment: true }">{{
                            "CREATE_DETACHMENT" | translate
                          }}</a>
                        <a ngbDropdownItem (click)="modalOpen(chooseCommission, row)" *ngIf="_authenticationService.hasCapability('edit_commission')">
                          {{ "INSERT_TO_EXISTING_COMMISSION" | translate }}
                        </a>
                      </div>
                    </span>
                    <!-- bottone commessa per prodotti -->
                    <span *ngIf="row.deal_type === 'Product' && (!row.commission || (!row.commission.name && !row.commission.id))" ngbDropdown>
                      <button ngbDropdownToggle [ngbTooltip]="'CREATE_COMMISSION' | translate" placement="left" class="btn px-0 py-0 font-weight-normal" type="button" id="dropdown-{{ row.id }}" rippleEffect>
                        <span class="text-center text-success">
                          <i data-feather="plus" size="19"></i>
                        </span>
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdown-{{ row.id }}">
                        <a
                          ngbDropdownItem
                          href="javascript:void(0)"
                          [routerLink]="'/dashboard/commissions/create-product-commission'"
                          [queryParams]="{ deal: row.id }"
                          *ngIf="_authenticationService.hasCapability('create_commission')"
                        >
                          {{ "CREATE_COMMISSION" | translate }}
                        </a>
                        <a ngbDropdownItem (click)="modalOpen(chooseCommission, row)" *ngIf="_authenticationService.hasCapability('edit_commission')">
                          {{ "INSERT_TO_EXISTING_COMMISSION" | translate }}
                        </a>
                      </div>
                    </span>
                    <a routerLink="/dashboard/commissions/edit-product-commission/{{ row.commission.id }}" *ngIf="!!row.commission && row.deal_type === 'Product'">{{ row.commission.name }}</a>
                    <a routerLink="/dashboard/commission/edit/{{ row.commission.id }}" *ngIf="!!row.commission && row.deal_type !== 'Product'">{{ row.commission.name }}</a>
                  </div>
                  <!--Azioni-->
                  <div class="col-12 d-flex justify-content-end">
                    <a
                      class="text-success"
                      [ngbTooltip]="'VIEW_FILE_DOCUMENT' | translate"
                      (click)="_utilService.getFile(row.document_url)"
                      *ngIf="_authenticationService.hasCapability('manage_deal_document') && row.document_url"
                    >
                      <span [data-feather]="'file-text'" size="19"></span>
                    </a>
                    <a
                      class="text-warning"
                      [ngbTooltip]="'GENERATE_PDF_DOCUMENT' | translate"
                      (click)="generateDocument(row.id, !!row.document_url, row.deal_type)"
                      *ngIf="!row.document_url && _authenticationService.hasCapability('manage_deal_document')"
                    >
                      <span [data-feather]="'download'" size="19"></span>
                    </a>
                    <a
                      *ngIf="row.deal_type === 'Task' || row.deal_type === 'Time Material'"
                      class="text-primary ml-1"
                      [ngbTooltip]="'DUPLICATE_OFFER' | translate"
                      [routerLink]="_authenticationService.hasCapability('create_deal') ? '/dashboard/deals/duplicate/' + row.id : null"
                    ><span [data-feather]="'copy'" size="19"></span
                    ></a>
                    <a
                      *ngIf="row.deal_type === 'Product'"
                      class="text-primary ml-1"
                      [ngbTooltip]="'DUPLICATE_OFFER' | translate"
                      [routerLink]="_authenticationService.hasCapability('create_deal') ? '/dashboard/deals/duplicate-product-deal/' + row.id : null"
                    ><span [data-feather]="'copy'" size="19"></span
                    ></a>
                    <a (click)="delete(row)" class="text-danger remove-item ml-1" *ngIf="_authenticationService.hasCapability('delete_deal')" [ngbTooltip]="'DELETE' | translate">
                      <span [data-feather]="'trash-2'" size="19"></span>
                    </a>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </core-card>
    </section>
  </div>
</div>

<!-- note choose Commission Modal -->
<ng-template #chooseCommission let-modal>
  <div>
    <div class="modal-header">
      <div></div>
    </div>
    <div class="modal-body" tabindex="0">
      <h3>{{ "SELECT_COMMISSION" | translate }}</h3>
      <div class="form-group mb-1">
        <label for="commission">{{ "DEAL_ORDER" | translate }}<sup class="text-danger">*</sup></label>
        <ng-select
          id="commission"
          bindLabel="complete_name"
          bindValue="id"
          [(ngModel)]="selectedCommissionID"
          [multiple]="false"
          [searchable]="true"
          [closeOnSelect]="true"
          [ngModelOptions]="{ standalone: true }"
          [clearable]="false"
          [openOnEnter]="false"
          [virtualScroll]="true"
          [items]="filteredCommissionList"
        ></ng-select>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button class="btn btn-outline-primary" (click)="modalClose()">{{ "BACK" | translate }}</button>
      <button [disabled]="!selectedCommissionID" (click)="goToCommission()" class="btn btn-primary w-150" rippleEffect>
        {{ "ADD_ROUND" | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- / note choose Commission Modal -->
